import { Typography } from "@mui/material";
import { useIntl } from "react-intl";
import { H1, H3, SECONDARY_MAIN } from "../../Constants/CommonConstants";
import {
  PREFERRED_METHOD_EMAIL,
  VERIFY_ACCOUNT_EMAIL_HEADER,
  VERIFY_ACCOUNT_HEADER_ID,
  VERIFY_ACCOUNT_PHONE_HEADER,
} from "../../Constants/VerifyAccountConstants";
import PropTypes from "prop-types";

/**
 * @description Header to be displayed for verifying the account based on preferred or selected verification method
 * @param {string} selectedVerificationMethod specifies the preferred verification method in case if only one verification method is registered or selcted verification method for login flow in case both phone and email are registered
 * @returns {ReactNode} Renders verify account header
 */
export const VerifyAccountHeader = ({ selectedVerificationMethod }) => {
  const intl = useIntl();
  return (
    <Typography
      component={H1}
      variant={H3}
      color={SECONDARY_MAIN}
      id={VERIFY_ACCOUNT_HEADER_ID}
    >
      {selectedVerificationMethod === PREFERRED_METHOD_EMAIL
        ? intl.formatMessage({ id: VERIFY_ACCOUNT_EMAIL_HEADER })
        : intl.formatMessage({ id: VERIFY_ACCOUNT_PHONE_HEADER })}
    </Typography>
  );
};

VerifyAccountHeader.propTypes = {
  /**
   * specifies the preferred verification method in case if only one verification method is registered or selcted verification method for login flow in case both phone and email are registered
   */
  selectedVerificationMethod: PropTypes.string.isRequired,
};
